import { render, staticRenderFns } from "./CustomSettingEdit.vue?vue&type=template&id=cefbee36"
import script from "../../../controllers/custom/setting/custom-setting-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/setting/custom-setting-edit.js?vue&type=script&lang=js&external"
import style0 from "./CustomSettingEdit.vue?vue&type=style&index=0&id=cefbee36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports